<template>
  <select :name="name" :id="id" v-model="selectEntity">
    <slot></slot>
  </select>
</template>

<script>
export default {
  props: ["name", "id", "value"],
  data: function() {
    return {
      selectEntity: ""
    };
  },
  mounted() {
    this.selectEntity = this.value;
  }
};
</script>
